export default {
  bankTransfer: 'Transferência bancária',
  firstTitle: 'Por favor, selecione a moeda da transferência',
  secondTitle: 'Após a transferência',
  bankTips:
    'Obtenha as informações do beneficiário e vá para a estação de trabalho bancária correspondente para preencher o formulário de transferência. Por favor, verifique cuidadosamente sua ortografia.',
  receiverTitle: 'Informações do beneficiário',
  bankAttrEnum: {
    0: 'Número da conta',
    1: 'Número de roteamento',
    2: 'Nome da conta',
    3: 'Nome do banco',
    4: 'Endereço do banco',
    5: 'Código postal',
    6: 'País/Região',
    7: 'Tipo de conta',
    8: 'Observações',
  },
  transferTips:
    'Você pode nos notificar através de qualquer um dos seguintes métodos, verificaremos o mais rápido possível!',
  transferName: 'Nome do remetente',
  transferBank: 'Banco do remetente',
  transferNo: 'Número de referência',
  submit: 'Enviar imediatamente',
  successSubmit: 'Enviado com sucesso',
  successSubmitTips:
    '* Se houver algum problema durante o processo de verificação, entraremos em contato com seu e-mail de registro acbuy.',
  tradeDetail: 'Detalhes da transação',
  backOrder: 'Voltar ao pedido',
  holder: {
    inputNo: 'Se houver número de referência, forneça.',
  },
  transferExplain: 'Instruções de transferência bancária:',
  transferExplainEnum: {
    0: 'O acbuy não cobra taxa de serviço para este canal de pagamento. Se o banco remetente cobra taxas depende das políticas relevantes do banco correspondente.',
    1: 'Este método de pagamento suporta múltiplas moedas. Os clientes podem escolher a conta bancária correspondente para transferência de acordo com sua região e necessidades.',
    2: 'Normalmente, o tempo de chegada é de 1-3 dias úteis; em circunstâncias especiais, o tempo de chegada é de 1-5 dias úteis.',
    3: 'Quando o acbuy receber a transferência, converterá o valor para RMB de acordo com a taxa de câmbio do acbuy e depositará em sua conta.',
    4: 'O valor final em RMB na conta acbuy = Seu valor de transferência * Taxa de câmbio da plataforma acbuy.',
  },
}
